export default "__VITE_ASSET__ZQGqtH3Z__"